import styled from 'styled-components';

const Wrapper = styled.div`
  height: 8em;
  left: 50%;
  margin-left: -4em;
  margin-top: -6em;
  position: absolute;
  top: 50%;
  width: 8em;
`;

export default Wrapper;
